/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontFeaturedSection_seller = {
    readonly sellerPreferences: {
        readonly urlLabel: string | null;
    } | null;
    readonly " $refType": "StorefrontFeaturedSection_seller";
};
export type StorefrontFeaturedSection_seller$data = StorefrontFeaturedSection_seller;
export type StorefrontFeaturedSection_seller$key = {
    readonly " $data"?: StorefrontFeaturedSection_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontFeaturedSection_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerPreferences",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'bc08d8a399155d5520d7651d9b726063';
export default node;
